import axios from 'axios';
import { sortBy } from 'lodash';
/**
 * services get api
 * to get all the premium services */
export async function getServices() {
  let services = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/market/place/premium/services`)
    .then((response) => {
      if (response.data) {
        services = sortBy(response.data.data.premium_services, 'sequence');
        localStorage.setItem('services', JSON.stringify(services));
      }
    })
    .catch((err) => {
      console.log('get services java api error', err); // eslint-disable-line no-console
    });
  return services;
}

/**
 * purchase get api
 * to get the purchase details */
export async function getPurchaseDetails() {
  let purchaseInfo = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/purchase?showAll=true`)
    .then((response) => {
      if (response.data) {
        purchaseInfo = response.data;
      }
    })
    .catch((err) => {
      console.log('purchase get api', err); // eslint-disable-line no-console
    });
  return purchaseInfo;
}

/**
 * services/summary get api
 * to get the summary based on the given service id */
export async function getServiceSummary(serviceId) {
  let services = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/market/place/premium/services/summary/${serviceId}`)
    .then((response) => {
      if (response.data) {
        services = response.data.data;
      }
    })
    .catch((err) => {
      console.log('services/summary java api error', err); // eslint-disable-line no-console
    });
  return services;
}

/**
 * premium/services/add post api
 * to add the premium service to account */
export async function addService(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/market/place/premium/services/add`, formData)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('services/add java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getServiceInfo() {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/admin/service/info`)
    .then((response) => {
      data = response.data.data;
    })
    .catch((err) => {
      console.log('get service java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * activate/service post api
 * to activate the service for accountid */
export async function activateService(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/activate/service`, formData)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('activate/service java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * /remove/service put api
 * to remove the activated service */
export async function removeService(formData) {
  let data = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/remove/service`, formData)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('/remove/service java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * /request/submit post api
 * to request the service */
export async function requestService(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/quote/request/submit`, formData)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('/request/submit java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getAccountsList(accountSearchValue) {
  let accountsList = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/admin/account/${accountSearchValue}`)
    .then((response) => {
      accountsList = response.data.data;
    })
    .catch((err) => {
      console.log('accountList err', err); // eslint-disable-line no-console
    });
  return accountsList;
}

export async function getActiveServices(accountId) {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/market/place/premium/services/${accountId}`)
    .then((response) => {
      data = response.data.data;
    })
    .catch((err) => {
      console.log('/market/place/premium/services/ java api error', err); // eslint-disable-line no-console
    });
  return data;
}

/**
 * /gg/request post api
 * to post the gg request */
export async function requestGreenLightService(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/gg/quote/request`, formData)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('/gg/quote.request python api error', err); // eslint-disable-line no-console
    });
  return data;
}
/**
 * services with rbac get api
 * to get all the premium services */
export async function getServicesListWithRBAC() {
  let services = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/market/place/servicerbac`)
    .then((response) => {
      if (response.data) {
        services = sortBy(response.data.data, 'sequence');
      }
    })
    .catch((err) => {
      console.log('get getServicesListWithRBAC java api error', err); // eslint-disable-line no-console
    });
  return services;
}

/**
 * add add-on
 */
export async function addOnSubscription(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/marketplace_cart`, formData)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('add on subscriptipn java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getServicesInCart() {
  let services = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/get_all_marketplace_cart`)
    .then((response) => {
      if (response.status === 200) {
        services = response.data;
      }
    })
    .catch((err) => {
      console.log('get marketplace_cart java api error', err); // eslint-disable-line no-console
    });
  return services;
}

export async function removeFromCartApi(id) {
  let data = '';
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/delete_marketplace_cart/${id}`)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('delete from cart java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function addToConfirm(formData) {
  let data = '';
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/marketplace_cart`, formData)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('add on subscriptipn java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function finalCartConfirm(formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/purchase`, formData)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('add on subscriptipn java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getAllPaymentModes() {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/payment/modes`)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('get payment modes java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getPaymentBillingPageData() {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/billing/info/payment_billing_page`)
    .then((response) => {
      data = response.data;
    })
    .catch((err) => {
      console.log('get payment billing data java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function cartPayment(cartId, formData) {
  let data = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/paymentapi/payments?cartId=${cartId}`, formData)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      data = err.response.data;
      console.log('post payments java api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function getPaymentDetails() {
  let data = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/paymentapi/payments`)
    .then((response) => {
      data = response;
    })
    .catch((err) => {
      console.log('get payments java api error', err); // eslint-disable-line no-console
    });
  return data;
}
